export const getFileNameFromURL = (url: string): string => {
  const result = url.match(/uploaded\/\d+\/.+\.css/gi);
  return result ? `...${result[result.length - 1].slice(20)}` : url;
};
